import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BRAND_NAME, SUPPORT_EMAIL, SUPPORT_PHONE } from '../api/config';
import { PageShell } from '../components/Layout';

function LegalSection({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-serif text-xl text-forest font-semibold mb-3">{title}</h2>
      <div className="text-sm text-ink/70 leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <h1 className="page-title">Terms of Use</h1>
        <p className="text-sm text-ink/50 mt-2">Effective: April 2026</p>

        <div className="mt-10 bg-white border border-sand p-6 md:p-10">
          <LegalSection title="Service">
            <p>
              {BRAND_NAME} provides access to Maharashtra property registry information for informational purposes.
              We are not affiliated with any government authority.
            </p>
          </LegalSection>
          <LegalSection title="No legal validity">
            <p>
              Reports and search results are not legal proof of ownership. Always verify with official IGR offices
              before making property decisions.
            </p>
          </LegalSection>
          <LegalSection title="Accuracy">
            <p>We do not guarantee completeness or accuracy of registry data. Users verify independently.</p>
          </LegalSection>
          <LegalSection title="Acceptable use">
            <p>Searches must be for lawful purposes. Scraping, abuse, or disruption of the service is prohibited.</p>
          </LegalSection>
          <LegalSection title="Governing law">
            <p>These terms are governed by the laws of India.</p>
          </LegalSection>
          <LegalSection title="Contact">
            <p>{SUPPORT_EMAIL} · {SUPPORT_PHONE}</p>
          </LegalSection>
        </div>

        <Link to="/" className="btn-outline mt-8 inline-flex">← Home</Link>
      </div>
    </PageShell>
  );
}
